<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="far fa-building fa-fw"
                            type="select"
                            placeholder="Todas"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            v-model="filtros.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-warehouse fa-fw"
                            placeholder="Selecione o Local..."
                            type="select"
                            service="estoque_locals.index"
                            optionsData="id_estoque_local"
                            optionsMode="aql"
                            v-model="filtros.id_estoque_local" />
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-4">
                        <az-input
                            icon="fas fa-funnel-dollar fa-fw"
                            placeholder="Todos os Centros de Custo..."
                            type="select"
                            service="centro_custos.index"
                            optionsData="id_centro_custo"
                            optionsMode="aql"
                            v-model="filtros.id_centro_custo" />
                    </div>
                    <div class="col col-12 col-md-5">
                        <az-input
                            icon="fab fa-google fa-fw"
                            placeholder="Todos os Grupos..."
                            type="select"
                            service="estoque_grupos.index"
                            optionsData="id_estoque_grupo"
                            optionsMode="aql"
                            v-model="filtros.id_estoque_grupo" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            type="button-group"
                            :optionsList="[
                                { id: 'M', search: 'Movimentação' }, 
                                { id: 'E', search: 'Emissão' }
                            ]"
                            v-model="filtros.tipo_data"
                            @input="load()" />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>        

        <az-empty-state v-if="!dados" msg="Nenhuma movimentação identificada." />

        <template v-else>

            <div class="alert alert-dark d-flex justify-content-between">
                <div>Período: {{ $util.getFormatDate(this.dados.periodo.inicio) }} a {{ $util.getFormatDate(this.dados.periodo.fim) }}</div>
                <div v-if="dados.unidade_operacao">{{ dados.unidade_operacao.search }}</div>
                <div v-if="dados.local">Local: {{ dados.local.search }}</div>
            </div>

            <div class="alert alert-danger d-flex justify-content-between">
                <div>Consumo por Centro de Custo</div>
                <div>
                    <a href="#" @click.prevent="expansao.consumo_centro = !expansao.consumo_centro">
                        <i class="fa-solid fa-minimize" v-if="expansao.consumo_centro"></i>
                        <i class="fa-solid fa-maximize" v-else></i>
                    </a>
                </div>
            </div>

            <div class="card-deck mb-3" v-if="expansao.consumo_centro">

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-body text-right">
                        <div v-if="dados">
                            <Chart 
                                type="horizontalBar" 
                                :data="info_grafico (lista_consumo_centro, 'st_nome', 'valor')" 
                                :options="{ 
                                    scales: { 
                                        yAxes: [{ 
                                            stacked: true, 
                                            barThickness: 32, 
                                            maxBarThickness: 48,
                                        }], 
                                        xAxes: [{ 
                                            stacked: true,
                                            barThickness: 32, 
                                            maxBarThickness: 48,
                                            ticks: {
                                                callback: function(value, index, values) {
                                                    return formatMoedaGrafico(value);
                                                }
                                            }
                                        }] 
                                    } 
                                }" />
                        </div>
                    </div>
                </div>

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-body">
                        <div v-if="dados" id="consumos">
                            <cabecalho-generico titulo="Consumo por Centro de Custo">
                                <div v-if="dados.unidade_operacao">{{ dados.unidade_operacao.search }}</div>
                                <div v-if="dados.local">Local: {{ dados.local.search }}</div>
                                <div>Período: {{ $util.getFormatDate(this.dados.periodo.inicio) }} a {{ $util.getFormatDate(this.dados.periodo.fim) }}</div>
                            </cabecalho-generico>

                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th>Centro de Custo</th>
                                        <th class="text-right">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(centro, icx) in lista_consumo_centro" :key="icx">
                                        <td>{{ centro.st_nome }}</td>
                                        <td class="text-right">{{ $util.formatMoeda(centro.valor) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot v-if="dados.consumos && dados.consumos.length">
                                    <tr>
                                        <th>Total</th>
                                        <th class="text-right">{{ $util.formatMoeda(totalizar(dados.consumos, 'valor')) }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <print-export printid="consumos" />
                    </div>
                </div>

            </div>

            <!-- Consumo por Grupo -->

            <div class="alert alert-danger d-flex justify-content-between">
                <div>Consumo por Grupo</div>
                <div>
                    <a href="#" @click.prevent="expansao.consumo_grupo = !expansao.consumo_grupo">
                        <i class="fa-solid fa-minimize" v-if="expansao.consumo_grupo"></i>
                        <i class="fa-solid fa-maximize" v-else></i>
                    </a>
                </div>
            </div>

            <div class="card-deck mb-3" v-if="expansao.consumo_grupo">

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        Consumo por Grupo
                    </div>
                    <div class="card-body text-right">
                        <div v-if="dados">
                            <Chart 
                                type="horizontalBar"  
                                :data="info_grafico (lista_consumo_grupo, 'st_nome', 'valor')" 
                                :options="{ 
                                    scales: { 
                                        yAxes: [{ 
                                            stacked: true, 
                                            barThickness: 32, 
                                            maxBarThickness: 48,
                                        }], 
                                        xAxes: [{ 
                                            stacked: true,
                                            ticks: {
                                                callback: function(value, index, values) {
                                                    return formatMoedaGrafico(value);
                                                }
                                            }
                                        }] 
                                    } 
                                }" />
                        </div>
                    </div>
                </div>                

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-header bg-primary text-white">
                        Consumo por Grupo
                    </div>
                    <div class="card-body">
                        <div v-if="dados" id="consumos-grupo">
                            <cabecalho-generico titulo="Consumo por Grupo">
                                <div v-if="dados.unidade_operacao">{{ dados.unidade_operacao.search }}</div>
                                <div v-if="dados.local">Local: {{ dados.local.search }}</div>
                                <div>Período: {{ $util.getFormatDate(this.dados.periodo.inicio) }} a {{ $util.getFormatDate(this.dados.periodo.fim) }}</div>
                            </cabecalho-generico>

                            <table class="table table-hover table-sm">
                                <thead>
                                    <tr>
                                        <th>Grupo</th>
                                        <th class="text-right">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(centro, icx) in lista_consumo_grupo" :key="icx">
                                        <td>
                                            <a href="#" @click.prevent="abrir_detalhe_mov(2, { id_estoque_grupo: centro.id_estoque_grupo })">
                                                {{ centro.st_nome }}
                                            </a>
                                        </td>
                                        <td class="text-right">{{ $util.formatMoeda(centro.valor) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot v-if="dados.consumos && dados.consumos.length">
                                    <tr>
                                        <th>Total</th>
                                        <th class="text-right">{{ $util.formatMoeda(totalizar(dados.consumos, 'valor')) }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <print-export printid="consumos-grupo" />
                    </div>
                </div>

            </div>

            <!-- Compras -->

            <div class="alert alert-success d-flex justify-content-between">
                <div>
                    Compras por Fornecedor
                    <span class="badge badge-success ml-2" v-if="dados.tipo_data == 'E'">Emissão</span>
                </div>
                <div>
                    <a href="#" @click.prevent="expansao.compra_fornecedor = !expansao.compra_fornecedor">
                        <i class="fa-solid fa-minimize" v-if="expansao.compra_fornecedor"></i>
                        <i class="fa-solid fa-maximize" v-else></i>
                    </a>
                </div>
            </div>

            <div class="card-deck mb-3" v-if="expansao.compra_fornecedor">

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-body text-right">
                        <div v-if="dados">
                            <Chart type="horizontalBar" :data="info_grafico (lista_compras_fornecedor, 'st_nome_fantasia', 'valor')" 
                            :options="{ 
                                scales: { 
                                    yAxes: [{ 
                                        stacked: true, 
                                        barThickness: 32, 
                                        maxBarThickness: 48,
                                    }], 
                                    xAxes: [{ 
                                        stacked: true,
                                        ticks: {
                                            callback: function(value, index, values) {
                                                return formatMoedaGrafico(value);
                                            }
                                        }
                                    }] 
                                } 
                            }" />
                        </div>
                    </div>
                </div>

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-body">
                        <div v-if="dados" id="compras">
                            <cabecalho-generico titulo="Compras por Fornecedor">
                                <div v-if="dados.unidade_operacao">{{ dados.unidade_operacao.search }}</div>
                                <div v-if="dados.local">Local: {{ dados.local.search }}</div>
                                <div>Período: {{ $util.getFormatDate(this.dados.periodo.inicio) }} a {{ $util.getFormatDate(this.dados.periodo.fim) }}</div>
                            </cabecalho-generico>

                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th>Fornecedor</th>
                                        <th class="text-right">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(fornecedor, icx) in lista_compras_fornecedor" :key="icx">
                                        <td>{{ fornecedor.st_nome_fantasia }}</td>
                                        <td class="text-right">{{ $util.formatMoeda(fornecedor.valor) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot v-if="lista_compras_fornecedor.length">
                                    <tr>
                                        <th>Total</th>
                                        <th class="text-right">{{ $util.formatMoeda(totalizar(lista_compras_fornecedor, 'valor')) }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <print-export printid="compras" />
                    </div>
                </div>

            </div>

            <!-- Compras por Grupo -->

            <div class="alert alert-success d-flex justify-content-between">
                <div>
                    Compras por Grupo
                    <span class="badge badge-success ml-2" v-if="dados.tipo_data == 'E'">Emissão</span>
                </div>
                <div>
                    <a href="#" @click.prevent="expansao.compra_grupo = !expansao.compra_grupo">
                        <i class="fa-solid fa-minimize" v-if="expansao.compra_grupo"></i>
                        <i class="fa-solid fa-maximize" v-else></i>
                    </a>
                </div>
            </div>

            <div class="card-deck mb-3" v-if="expansao.compra_grupo">

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-body text-right">
                        <div v-if="dados">
                            <Chart type="horizontalBar" :data="info_grafico (lista_compras_grupo, 'st_nome', 'valor')" 
                            :options="{ 
                                scales: { 
                                    yAxes: [{ 
                                        stacked: true, 
                                        barThickness: 32, 
                                        maxBarThickness: 48,
                                    }], 
                                    xAxes: [{ 
                                        stacked: true,
                                        ticks: {
                                            callback: function(value, index, values) {
                                                return formatMoedaGrafico(value);
                                            }
                                        }
                                    }] 
                                } 
                            }" />
                        </div>
                    </div>
                </div>

                <div class="card card-dash dashcard" style="padding: 0px;">
                    <div class="card-body">
                        <div v-if="dados" id="compras-grupo">
                            <cabecalho-generico titulo="Compras por Grupo">
                                <div v-if="dados.unidade_operacao">{{ dados.unidade_operacao.search }}</div>
                                <div v-if="dados.local">Local: {{ dados.local.search }}</div>
                                <div>Período: {{ $util.getFormatDate(this.dados.periodo.inicio) }} a {{ $util.getFormatDate(this.dados.periodo.fim) }}</div>
                            </cabecalho-generico>

                            <table class="table table-sm table-hover">
                                <thead>
                                    <tr>
                                        <th>Grupo</th>
                                        <th class="text-right">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(grupo, icx) in lista_compras_grupo" :key="icx">
                                        <td>
                                            <a href="#" @click.prevent="abrir_detalhe_mov(3, { id_estoque_grupo: grupo.id_estoque_grupo })">
                                                {{ grupo.st_nome }}
                                            </a>
                                        </td>
                                        <td class="text-right">{{ $util.formatMoeda(grupo.valor) }}</td>
                                    </tr>
                                </tbody>
                                <tfoot v-if="lista_compras_grupo.length">
                                    <tr>
                                        <th>Total</th>
                                        <th class="text-right">{{ $util.formatMoeda(totalizar(lista_compras_grupo, 'valor')) }}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <print-export printid="compras-grupo" />
                    </div>
                </div>

            </div>

            <!-- Lotes -->

            <div class="alert alert-warning d-flex justify-content-between">
                <div>Vencimento de Lotes</div>
                <div>
                    <a href="#" @click.prevent="expansao.lote = !expansao.lote">
                        <i class="fa-solid fa-minimize" v-if="expansao.lote"></i>
                        <i class="fa-solid fa-maximize" v-else></i>
                    </a>
                </div>
            </div>

            <div class="card card-dash dashcard" style="padding: 0px;" v-if="expansao.lote">
                <template v-if="dados.lotes && dados.lotes.length">
                    <div class="card-body">
                        <div v-if="dados" id="lotes">
                            <cabecalho-generico titulo="Vencimento de Lotes">
                                <div v-if="dados.unidade_operacao">{{ dados.unidade_operacao.search }}</div>
                                <div v-if="dados.local">Local: {{ dados.local.search }}</div>
                                <div>Validade: {{ $util.getFormatDate(this.dados.periodo.inicio) }} a {{ $util.getFormatDate(this.dados.periodo.fim) }}</div>
                            </cabecalho-generico>

                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Item</th>
                                        <th>Id</th>
                                        <th>Lote</th>
                                        <th>Validade</th>
                                        <th class="text-right">Saldo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-for="(lotes, grupo, icx) in agrupar(dados.lotes, 'lote_info')">
                                        <tr :key="'G' + icx" :class="lotes[0].lote_color ? 'table-' + lotes[0].lote_color : 'table-secondary'">
                                            <td colspan="5"><strong>{{ grupo }}</strong></td>
                                        </tr>
                                        <tr v-for="(lote, icx) in lotes" :key="icx"
                                            :class="lote.lote_color ? 'table-' + lote.lote_color : ''">
                                            <td>{{ lote.item.search }}</td>
                                            <td>#{{ lote.item.id_estoque_item }}</td>
                                            <td>{{ lote.st_lote }}</td>
                                            <td>{{ $util.getFormatDate(lote.dt_validade) }}</td>
                                            <td class="text-right">
                                                <a href="#" @click.prevent="exibir_saldos_por_local(lote)" class="card-link">
                                                    {{ lote.saldo.qtd }}
                                                </a>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="card-footer">
                        <print-export printid="lotes" />
                    </div>
                </template>

                <template v-else>
                    <div class="card-body">
                        Nenhum lote identificado
                    </div>
                </template>
            </div>

            <br><br><br><br><br>

            <pre class="alert alert-info" v-if="false">{{ dados }}</pre>
        </template>

        <saldos-por-local ref="saldos_por_local" />

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import SaldosPorLocal from './SaldosPorLocal.vue';


export default {
    data() { 
        return { 
            search: "",
            viewMode: "S", 
            dados: null,
            firstload: false,
            montando: true, 
            filtros: { 
                tipo_data: 'M', 
                inicio: this.$util.hoje(),
                fim: this.$util.hoje(),           
                id_estoque_local: this.$util.getCookie('estoque-armazem'),
                periodo: "ma",
                id_unidade_operacao: "", 
                id_centro_custo: "", 
                id_estoque_grupo: "",
                id_fornecedor: "", 
            },
            titulo: "...",
            tipo: null, 
            movimentacoes: [], 
            doc: null, 
            validate: false, 
            removendo: false, 
            expansao: { 
                consumo_centro: true, 
                consumo_grupo: true,
                compra_fornecedor: true,
                compra_grupo: true,
                lote: true,
            },
        }
    },

    components: { 
        AzInput,
        AzEmptyState,
        AzPeriodo, 
        PrintExport,
        CabecalhoGenerico, 
        SaldosPorLocal,
    },

    computed: { 
        lista_consumo_centro: function () { 
            if ( !this.dados || !this.dados.consumos )
                return [];

            return _.orderBy(
                _.map(
                    _.groupBy(this.dados.consumos.filter(item => item.valor), 'st_nome'), 
                    (itens, chave) => { 
                        return {
                            st_nome: chave,
                            valor: _.sumBy(itens, 'valor')
                        };
                    }
                )
                , 'valor'
                , 'desc'
            );
        },

        lista_consumo_grupo: function () { 
            if ( !this.dados || !this.dados.consumos )
                return [];

            return _.orderBy(
                    _.map(
                        _.groupBy(this.dados.consumos.filter(item => item.valor), 'st_estoque_grupo'), 
                        (itens, chave) => { 
                            return {
                                id_estoque_grupo: _.get(itens, '0.id_estoque_grupo'), 
                                st_nome: chave,
                                valor: _.sumBy(itens, 'valor')
                            };
                        }
                    )
                    , 'valor'
                    , 'desc'
                );
        },

        lista_compras_grupo: function () { 
            if ( !this.dados || !this.dados.compras )
                return [];

            return _.orderBy(
                    _.map(
                        _.groupBy(this.dados.compras.filter(item => item.valor), 'st_estoque_grupo'), 
                        (itens, chave) => { 
                            return {
                                id_estoque_grupo: _.get(itens, '0.id_estoque_grupo'), 
                                st_nome: chave,
                                valor: _.sumBy(itens, 'valor')
                            };
                        }
                    )
                    , 'valor'
                    , 'desc'
                );
        },

        lista_compras_fornecedor: function () { 
            if ( !this.dados || !this.dados.compras )
                return [];

            return _.orderBy(
                _.map(
                    _.groupBy(this.dados.compras.filter(item => item.valor), 'st_nome_fantasia'), 
                    (itens, chave) => { 
                        return {
                            id_fornecedor: _.get(itens, '0.id_fornecedor'), 
                            st_nome_fantasia: chave,
                            valor: _.sumBy(itens, 'valor')
                        };
                    }
                )
                , 'valor'
                , 'desc'
            );
        },

        lista_items: function () { 
            if ( !this.movimentacoes )
                return [];

            return this.movimentacoes.filter(item => item.fl_ativo);
        },

        valor_total: function () { 
            return this.lista_items.reduce((total, carry) => total + parseFloat(carry.dc_valor * carry.in_quantidade), 0);
        },

    },

    props: ['id'],

    methods: { 
        abrir_detalhe_mov (id_estoque_tipo_movimentacao, parms) { 
            this.$router.push({ 
                name: 'suprimentos', 
                params: { 
                    aba: 'movimentacao', 
                    filtros: { 
                        id_estoque_tipo_movimentacao: id_estoque_tipo_movimentacao, 
                        ...this.filtros, 
                        ...parms 
                    }
                },  
            });
        },

        agrupar (lista, campo) { 
            return _.groupBy(lista, campo);
        },

        exibir_saldos_por_local(item) {
            $('[data-toggle="tooltip"]').tooltip('dispose');

            this.$refs.saldos_por_local.abrir(item);
        },

        totalizar (lista, campo) { 
            return lista.reduce((total, carry) => { 
                return total + parseFloat(carry[campo]);
            }, 0);
        },

        formatMoedaGrafico(value) { 
            let show = this.$util.formatMoeda(value);
            return show.substr(0,show.length - 3);
        },

        info_grafico (lista, label, value) { 
            if ( !lista )
                return { labels: [] };

            let valores = lista.map(item => { 
                return { 
                    label: ( item[label] && item[label] != 'null' ) ? item[label] : '?',
                    value: item[value], 
                }
            })

            valores = _.orderBy(valores, 'value', 'desc');

            if ( valores.length > 12 ) { 
                let outros = _.slice(valores, 12);
                valores = _.slice(valores, 0, 12);
                valores.push({
                    label: 'Outros',
                    value: this.totalizar(outros, 'value'), 
                });
            }

            // valores = _.orderBy(valores, 'label', 'asc');

            let grafico = {
				labels: _.map(valores, (item) => ( ( item.label && item.label != 'null' ) ? item.label : '?' )),
				datasets: [
					{
						label: 'Total',
                        backgroundColor: 'rgba(0,255,0,0.8)',
                        borderColor: '#33CC11',
                        fill: true, 
						data: _.map(valores, (item) => item.value),
					}
				]
            };
            
            return grafico;

        },

        remover_item(material) { 
            this.removendo = true;
            
            this.$nextTick(() => { 
                material.fl_ativo = false
                this.removendo = false;
            });
        },

        incluir_item(novo) { 
            if ( !novo )
                return;

            let busca = this.movimentacoes.find(item => item.fl_ativo 
                && item.item.id_estoque_item == novo.id_estoque_item
                && ( _.get(novo, 'lote.item') || _.get(item, 'lote.st_lote') == _.get(novo, 'lote.item.st_lote') ) );

            if ( busca ) { 
                busca.in_quantidade = parseInt(busca.in_quantidade) + parseInt( novo.quantidade ? novo.quantidade : 1 );
                return; 
            }

            let lote = _.get(novo, 'lote.item') 
                ? _.get(novo, 'lote.item') 
                : ( 
                    _.get(novo, 'lote.numero') 
                        ? { 
                            st_lote: _.get(novo, 'lote.numero'),
                            dt_validade: _.get(novo, 'lote.validade')
                        } 
                        : null
                 ) ;

            this.movimentacoes.push({ 
                id_estoque_movimentacao: null, 
                id_estoque_item: null, 
                id_estoque_local: this.filtros.id_estoque_local, 
                id_estoque_tipo_movimentacao: this.id, 
                item: novo, 
                in_quantidade: novo.quantidade ? novo.quantidade : 1,
                fl_pendente: true, 
                st_observacao: "", 
                fl_ativo: true, 
                lote: lote, 
            });
        },

        incluir() { 
            this.validate = false;
            this.doc = "";
            this.movimentacoes = [];

            $('#movimentarAddModal').modal('show');
        },

        atualizar() { 

            if ( !this.movimentacoes || !this.movimentacoes.filter(item => item.fl_ativo).length ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione o material.",
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, { 
                service: "estoque",
                func: "outros_movimentar",
                dados: { 
                    movs: this.movimentacoes,
                    id_estoque_tipo_movimentacao: this.id, 
                    doc: this.doc, 
                },
                modal: 'movimentarAddModal',
                reload: true, 
            });

        },

        load() { 
            if ( this.montando )
                return;

            this.$util.load(this, { 
                service: 'estoque',
                func: 'visao_geral',
                parms: { 
                    ...this.filtros, 
                },
            });
        },
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Visão Geral", path: "/suprimentos/visao" }
        ]);
        
        this.$nextTick(() => { 
            this.montando = false;
            this.load();
        });
    }
}
</script>